"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomersScreen = CustomersScreen;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var confirm_dialog_1 = require("../../components/common/confirm-dialog");
var data_table_1 = require("../../components/common/data-table");
var page_header_1 = require("../../components/common/page-header");
var permission_gate_1 = require("../../components/common/permission-gate");
var search_input_1 = require("../../components/common/search-input");
var status_badge_1 = require("../../components/common/status-badge");
var customers_1 = require("../../features/apis/customers");
var organizations_1 = require("../../features/apis/organizations");
var use_error_handler_1 = require("../../hooks/use-error-handler");
var use_permissions_1 = require("../../hooks/use-permissions");
var customer_1 = require("../../interfaces/customer");
var organization_1 = require("../../interfaces/organization");
var permissions_1 = require("../../interfaces/permissions");
function PlusIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { className: "h-4 w-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 4v16m8-8H4" }) }));
}
function CustomersScreen() {
    var _this = this;
    var _a, _b, _c, _d;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var hasPermission = (0, use_permissions_1.usePermissions)().hasPermission;
    var _e = (0, use_error_handler_1.useErrorHandler)(), handleError = _e.handleError, handleSuccess = _e.handleSuccess;
    var _f = (0, react_2.useState)(1), page = _f[0], setPage = _f[1];
    var _g = (0, react_2.useState)(""), search = _g[0], setSearch = _g[1];
    var _h = (0, react_2.useState)(""), statusFilter = _h[0], setStatusFilter = _h[1];
    var _j = (0, react_2.useState)(""), organizationFilter = _j[0], setOrganizationFilter = _j[1];
    var _k = (0, react_1.useDisclosure)(), isFormOpen = _k.isOpen, onFormOpen = _k.onOpen, onFormClose = _k.onClose;
    var _l = (0, react_1.useDisclosure)(), isDeleteOpen = _l.isOpen, onDeleteOpen = _l.onOpen, onDeleteClose = _l.onClose;
    var _m = (0, react_2.useState)(null), editingCustomer = _m[0], setEditingCustomer = _m[1];
    var _o = (0, react_2.useState)(null), deletingCustomer = _o[0], setDeletingCustomer = _o[1];
    // Form state
    var _p = (0, react_2.useState)({
        organization_id: "",
        msisdn: "",
        name: "",
        surname: "",
        initials: "",
        id_number: "",
        contract_number: "",
        entity_name: "",
        status: customer_1.ECustomerStatus.ACTIVE,
    }), formData = _p[0], setFormData = _p[1];
    var _q = (0, customers_1.useGetCustomersQuery)({
        page: page,
        limit: 10,
        search: search || undefined,
        status: statusFilter || undefined,
        organization_id: organizationFilter || undefined,
    }), data = _q.data, isLoading = _q.isLoading, isFetching = _q.isFetching;
    var orgsData = (0, organizations_1.useGetOrganizationsQuery)({
        page: 1,
        limit: 100,
        status: organization_1.EOrganizationStatus.ACTIVE,
    }).data;
    var _r = (0, customers_1.useCreateCustomerMutation)(), createCustomer = _r[0], isCreating = _r[1].isLoading;
    var _s = (0, customers_1.useUpdateCustomerMutation)(), updateCustomer = _s[0], isUpdating = _s[1].isLoading;
    var _t = (0, customers_1.useDeleteCustomerMutation)(), deleteCustomer = _t[0], isDeleting = _t[1].isLoading;
    var customers = ((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.customers) || [];
    var totalPages = ((_c = (_b = data === null || data === void 0 ? void 0 : data.content) === null || _b === void 0 ? void 0 : _b.pagination) === null || _c === void 0 ? void 0 : _c.total_pages) || 1;
    var organizations = ((_d = orgsData === null || orgsData === void 0 ? void 0 : orgsData.content) === null || _d === void 0 ? void 0 : _d.organizations) || [];
    var getOrganizationName = function (customer) {
        if (typeof customer.organization_id === "object" && customer.organization_id) {
            return customer.organization_id.name;
        }
        if (customer.organization) {
            return customer.organization.name;
        }
        return String(customer.organization_id);
    };
    var columns = [
        {
            key: "msisdn",
            label: "Phone Number",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "font-medium text-foreground", children: item.msisdn }); },
        },
        {
            key: "name",
            label: "Name",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-600", children: item.full_name || item.name || item.surname || "-" }); },
        },
        {
            key: "organization",
            label: "Organization",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: getOrganizationName(item) }); },
        },
        {
            key: "entity_name",
            label: "Entity",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: item.entity_name || "-" }); },
        },
        {
            key: "total_orders",
            label: "Orders",
            render: function (item) { return (0, jsx_runtime_1.jsx)("span", { className: "text-default-500", children: item.total_orders }); },
        },
        {
            key: "status",
            label: "Status",
            render: function (item) { return (0, jsx_runtime_1.jsx)(status_badge_1.StatusBadge, { status: item.status }); },
        },
        {
            key: "actions",
            label: "Actions",
            align: "end",
            render: function (item) { return ((0, jsx_runtime_1.jsxs)("div", { className: "flex justify-end gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", onPress: function () { return navigate("/customers/".concat(item._id)); }, children: "View" }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.CUSTOMERS, action: permissions_1.ACTIONS.UPDATE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "primary", onPress: function () { return handleEdit(item); }, children: "Edit" }) }), (0, jsx_runtime_1.jsx)(permission_gate_1.PermissionGate, { module: permissions_1.MODULES.CUSTOMERS, action: permissions_1.ACTIONS.DELETE, children: (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "light", color: "danger", isDisabled: item.status === customer_1.ECustomerStatus.INACTIVE, onPress: function () { return handleDeleteClick(item); }, children: "Deactivate" }) })] })); },
        },
    ];
    var handleCreate = function () {
        setEditingCustomer(null);
        setFormData({
            organization_id: organizationFilter || "",
            msisdn: "",
            name: "",
            surname: "",
            initials: "",
            id_number: "",
            contract_number: "",
            entity_name: "",
            status: customer_1.ECustomerStatus.ACTIVE,
        });
        onFormOpen();
    };
    var handleEdit = function (customer) {
        setEditingCustomer(customer);
        var orgId = typeof customer.organization_id === "object" ? customer.organization_id._id : customer.organization_id;
        setFormData({
            organization_id: orgId,
            msisdn: customer.msisdn,
            name: customer.name || "",
            surname: customer.surname || "",
            initials: customer.initials || "",
            id_number: customer.id_number || "",
            contract_number: customer.contract_number || "",
            entity_name: customer.entity_name || "",
            status: customer.status,
        });
        onFormOpen();
    };
    var handleDeleteClick = function (customer) {
        setDeletingCustomer(customer);
        onDeleteOpen();
    };
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!editingCustomer) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateCustomer({
                            id: editingCustomer._id,
                            data: {
                                organization_id: formData.organization_id || undefined,
                                name: formData.name || undefined,
                                surname: formData.surname || undefined,
                                initials: formData.initials || undefined,
                                id_number: formData.id_number || undefined,
                                contract_number: formData.contract_number || undefined,
                                entity_name: formData.entity_name || undefined,
                                status: formData.status,
                            },
                        }).unwrap()];
                case 1:
                    _a.sent();
                    handleSuccess("Customer updated successfully");
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createCustomer({
                        organization_id: formData.organization_id,
                        msisdn: formData.msisdn,
                        name: formData.name || undefined,
                        surname: formData.surname || undefined,
                        initials: formData.initials || undefined,
                        id_number: formData.id_number || undefined,
                        contract_number: formData.contract_number || undefined,
                        entity_name: formData.entity_name || undefined,
                    }).unwrap()];
                case 3:
                    _a.sent();
                    handleSuccess("Customer created successfully");
                    _a.label = 4;
                case 4:
                    onFormClose();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    handleError(error_1, {
                        defaultMessage: editingCustomer ? "Failed to update customer" : "Failed to create customer",
                    });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!deletingCustomer)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteCustomer(deletingCustomer._id).unwrap()];
                case 2:
                    _a.sent();
                    handleSuccess("Customer deactivated successfully");
                    onDeleteClose();
                    setDeletingCustomer(null);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    handleError(error_2, { defaultMessage: "Failed to deactivate customer" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Build actions array conditionally based on permissions
    var headerActions = [];
    if (hasPermission(permissions_1.MODULES.CUSTOMERS, permissions_1.ACTIONS.CREATE)) {
        headerActions.push({
            label: "Add Customer",
            icon: (0, jsx_runtime_1.jsx)(PlusIcon, {}),
            onClick: handleCreate,
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "space-y-6", children: [(0, jsx_runtime_1.jsx)(page_header_1.PageHeader, { title: "Customers", description: "Manage customers and recipients", actions: headerActions }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-4", children: [(0, jsx_runtime_1.jsx)(search_input_1.SearchInput, { placeholder: "Search customers...", value: search, onChange: setSearch, className: "w-64" }), (0, jsx_runtime_1.jsxs)("select", { value: organizationFilter, onChange: function (e) {
                            setOrganizationFilter(e.target.value);
                            setPage(1);
                        }, className: "h-8 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "All Organizations" }), organizations.map(function (org) { return ((0, jsx_runtime_1.jsx)("option", { value: org._id, children: org.name }, org._id)); })] }), (0, jsx_runtime_1.jsxs)("select", { value: statusFilter, onChange: function (e) {
                            setStatusFilter(e.target.value);
                            setPage(1);
                        }, className: "h-8 rounded-lg border border-default-300 bg-default-100 px-2 text-sm text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "All Statuses" }), (0, jsx_runtime_1.jsx)("option", { value: "active", children: "Active" }), (0, jsx_runtime_1.jsx)("option", { value: "inactive", children: "Inactive" })] })] }), (0, jsx_runtime_1.jsx)(data_table_1.DataTable, { columns: columns, data: customers, isLoading: isLoading || isFetching, page: page, totalPages: totalPages, onPageChange: setPage, onRowClick: function (item) { return navigate("/customers/".concat(item._id)); }, emptyContent: "No customers found" }), (0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isFormOpen, onClose: onFormClose, size: "lg", disableAnimation: true, children: (0, jsx_runtime_1.jsxs)(react_1.ModalContent, { children: [(0, jsx_runtime_1.jsx)(react_1.ModalHeader, { children: editingCustomer ? "Edit Customer" : "Create Customer" }), (0, jsx_runtime_1.jsx)(react_1.ModalBody, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("label", { className: "mb-1.5 block text-sm text-default-600", children: ["Organization ", (0, jsx_runtime_1.jsx)("span", { className: "text-danger", children: "*" })] }), (0, jsx_runtime_1.jsxs)("select", { value: formData.organization_id, onChange: function (e) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { organization_id: e.target.value })); }); }, required: true, className: "w-full rounded-lg border border-default-300 bg-default-100 px-3 py-2.5 text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary focus:ring-2 focus:ring-primary/20", children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Select organization" }), organizations.map(function (org) { return ((0, jsx_runtime_1.jsx)("option", { value: org._id, children: org.name }, org._id)); })] })] }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Phone Number (MSISDN)", placeholder: "e.g., 0812345678", value: formData.msisdn, onValueChange: function (value) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { msisdn: value })); }); }, isRequired: true, isDisabled: !!editingCustomer }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-2 gap-4", children: [(0, jsx_runtime_1.jsx)(react_1.Input, { label: "Surname", placeholder: "Enter surname", value: formData.surname, onValueChange: function (value) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { surname: value })); }); } }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Initials", placeholder: "e.g., JD", value: formData.initials, onValueChange: function (value) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { initials: value })); }); } })] }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "ID Number", placeholder: "Enter ID number", value: formData.id_number, onValueChange: function (value) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { id_number: value })); }); } }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Contract Number", placeholder: "Enter contract number", value: formData.contract_number, onValueChange: function (value) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { contract_number: value })); }); } }), (0, jsx_runtime_1.jsx)(react_1.Input, { label: "Entity Name", placeholder: "Enter entity/department name", value: formData.entity_name, onValueChange: function (value) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { entity_name: value })); }); } }), editingCustomer && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { className: "mb-1.5 block text-sm text-default-600", children: "Status" }), (0, jsx_runtime_1.jsxs)("select", { value: formData.status, onChange: function (e) { return setFormData(function (prev) { return (__assign(__assign({}, prev), { status: e.target.value })); }); }, className: "w-full rounded-lg border border-default-300 bg-default-100 px-3 py-2.5 text-foreground outline-none transition-colors hover:bg-default-200 focus:border-primary focus:ring-2 focus:ring-primary/20", children: [(0, jsx_runtime_1.jsx)("option", { value: customer_1.ECustomerStatus.ACTIVE, children: "Active" }), (0, jsx_runtime_1.jsx)("option", { value: customer_1.ECustomerStatus.INACTIVE, children: "Inactive" })] })] }))] }) }), (0, jsx_runtime_1.jsxs)(react_1.ModalFooter, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "bordered", onPress: onFormClose, isDisabled: isCreating || isUpdating, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { color: "primary", onPress: handleSubmit, isLoading: isCreating || isUpdating, isDisabled: !formData.organization_id || !formData.msisdn || isCreating || isUpdating, children: editingCustomer ? "Update" : "Create" })] })] }) }), (0, jsx_runtime_1.jsx)(confirm_dialog_1.ConfirmDialog, { isOpen: isDeleteOpen, onClose: onDeleteClose, onConfirm: handleDelete, title: "Deactivate Customer", message: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Are you sure you want to deactivate customer ", (0, jsx_runtime_1.jsx)("strong", { children: deletingCustomer === null || deletingCustomer === void 0 ? void 0 : deletingCustomer.msisdn }), "? This will mark the customer as inactive."] }), confirmLabel: "Deactivate", confirmColor: "danger", isLoading: isDeleting })] }));
}
